// app/javascript/controllers/flash_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
      duration: {type: Number, default: 4000},
    type: { type: String, default: 'notice' }
  }

  connect() {
    this.showToast()
    this.autoDismiss()
  }

  showToast() {
    // Add entrance animation
    this.element.classList.remove('opacity-0', 'translate-y-2')
    this.element.classList.add('opacity-100', 'translate-y-0')
  }

  dismiss() {
    // Add exit animation
    this.element.classList.remove('opacity-100', 'translate-y-0')
    this.element.classList.add('opacity-0', 'translate-y-2')

    // Remove the element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }

  autoDismiss() {
    if (this.durationValue > 0) {
      setTimeout(() => {
        this.dismiss()
      }, this.durationValue)
    }
  }

  // Allow dismissing with Escape key
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.dismiss()
    }
  }
}
